/**
 * PortalSettingsPage - Card-based navigation for Customer Portal settings
 * Similar to CommunicationSettingsPage design
 */
import React from 'react';
import { 
  Globe, Palette, Settings, Calendar, Code, Layers, 
  Sparkles, MessageSquare, Clock, FileText, Coins, KeyRound, Cloud, Bell 
} from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

const PortalSettingsPage = () => {
  const navigate = useNavigate();
  
  const portalCards = [
    {
      id: 'appearance',
      icon: Palette,
      color: 'green',
      bgColor: 'bg-green-100',
      iconColor: 'text-green-600',
      title: 'Aussehen',
      description: 'Farben, Logo und Design des Portals',
      path: '/portal-settings/appearance'
    },
    {
      id: 'content',
      icon: Settings,
      color: 'purple',
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-600',
      title: 'Inhalt & Kontakt',
      description: 'Studio-Infos und Kontaktdaten',
      path: '/portal-settings/content'
    },
    {
      id: 'booking',
      icon: Calendar,
      color: 'orange',
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-600',
      title: 'Buchungsregeln',
      description: 'Vorlaufzeit, Stornierung, Anmeldung',
      path: '/portal-settings/booking'
    },
    {
      id: 'google-oauth',
      icon: KeyRound,
      color: 'red',
      bgColor: 'bg-red-100',
      iconColor: 'text-red-600',
      title: 'Google Login',
      description: 'Google-Anmeldung für Kunden',
      path: '/portal-settings/google-oauth'
    },
    {
      id: 'icloud-sync',
      icon: Cloud,
      color: 'sky',
      bgColor: 'bg-sky-100',
      iconColor: 'text-sky-600',
      title: 'iCloud Sync',
      description: 'Kontakte mit iPhone synchronisieren',
      path: '/portal-settings/icloud-sync'
    },
    {
      id: 'tracking-rewards',
      icon: Coins,
      color: 'yellow',
      bgColor: 'bg-yellow-100',
      iconColor: 'text-yellow-600',
      title: 'Tracking-Punkte',
      description: 'Belohnungen für Ernährungs-Tracking',
      path: '/portal-settings/tracking-rewards'
    },
    {
      id: 'insurance',
      icon: FileText,
      color: 'cyan',
      bgColor: 'bg-cyan-100',
      iconColor: 'text-cyan-600',
      title: 'Krankenkassenformulare',
      description: 'Formulare für Kunden hochladen',
      path: '/portal-settings/insurance'
    },
    {
      id: 'embed',
      icon: Code,
      color: 'gray',
      bgColor: 'bg-gray-100',
      iconColor: 'text-gray-600',
      title: 'Einbettung',
      description: 'iFrame-Code für Ihre Website',
      path: '/portal-settings/embed'
    }
  ];

  return (
    <div className="p-8 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Globe className="h-6 w-6 text-green-500" />
          Kundenportal Einstellungen
        </h1>
        <p className="text-gray-600 mt-1">
          Passen Sie das Erscheinungsbild und die Funktionen Ihres Kundenportals an
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {portalCards.map(card => {
          const Icon = card.icon;
          return (
            <Card
              key={card.id}
              className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02]"
              onClick={() => navigate(card.path)}
            >
              <CardHeader>
                <CardTitle className="flex items-center gap-3">
                  <div className={`p-3 rounded-lg ${card.bgColor}`}>
                    <Icon className={`h-6 w-6 ${card.iconColor}`} />
                  </div>
                  <span>{card.title}</span>
                </CardTitle>
                <CardDescription>{card.description}</CardDescription>
              </CardHeader>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default PortalSettingsPage;
